// mishya sticky add to cart (snippets/mishya-sticky-atc.liquid).
// Mirrors the product page's own Add to cart button and clicks it, so the theme's product form
// handles everything (size required, quantity, cart drawer). No data is sent anywhere by this file.
if (!customElements.get('mishya-sticky-atc')) {
  customElements.define(
    'mishya-sticky-atc',
    class MishyaStickyAtc extends HTMLElement {
      connectedCallback() {
        const sectionId = this.dataset.sectionId;
        this.mainButton = document.getElementById(`ProductSubmitButton-${sectionId}`);
        if (!this.mainButton) return;

        this.buttons = this.mainButton.closest('.product-form__buttons');
        this.picker = document.getElementById(`variant-selects-${sectionId}`);
        this.button = this.querySelector('.mishya-sticky-atc__button');
        this.label = this.querySelector('.mishya-sticky-atc__label');
        this.hidden = false;

        this.button.addEventListener('click', this.onClick.bind(this));
        this.sync();
        this.mirror = new MutationObserver(() => this.sync());
        this.mirror.observe(this.mainButton, { attributes: true, childList: true, subtree: true, characterData: true });
        if (this.buttons) this.mirror.observe(this.buttons, { attributes: true, attributeFilter: ['data-awaiting-variant'] });

        // Show the bar only while the page's own button is above the viewport (scrolled past). A scroll check,
        // not an IntersectionObserver, so it also works when the page opens already scrolled or jumps past the button.
        this.onScroll = () => {
          if (this.ticking) return;
          this.ticking = true;
          requestAnimationFrame(() => {
            this.ticking = false;
            this.classList.toggle('is-visible', this.mainButton.getBoundingClientRect().bottom < 0);
          });
        };
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll, { passive: true });
        this.onScroll();
      }

      disconnectedCallback() {
        if (this.mirror) this.mirror.disconnect();
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
      }

      awaitingSize() {
        return Boolean(this.buttons && this.buttons.hasAttribute('data-awaiting-variant'));
      }

      sync() {
        const mainLabel = this.mainButton.querySelector('span');
        if (mainLabel) this.label.textContent = mainLabel.textContent.trim();
        // While no size is chosen the main button is disabled, but this one stays usable to jump to the sizes
        this.button.disabled = this.mainButton.disabled && !this.awaitingSize();
      }

      onClick() {
        if (this.awaitingSize() && this.picker) {
          this.picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
          const firstChoice = this.picker.querySelector('input:not([disabled]), select');
          if (firstChoice) firstChoice.focus({ preventScroll: true });
          return;
        }
        if (!this.mainButton.disabled) this.mainButton.click();
      }
    }
  );
}
